import generatedLocaleList from 'locale/allLocales'

export const types = {
  SET: 'locale.SET',
}
export const allLocales = generatedLocaleList

export function setLocale(locale) {
  return {
    type: types.SET,
    payload: locale,
  }
}
